import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TPageError } from 'datasource/PortfolioProcessLayout/PortfolioFlowLayoutManager.types';
import { Infobox } from '../../ui-library';

export type ErrorItem = TPageError | undefined;

interface InfoErrorListProps {
    errors?: ErrorItem[] | ErrorItem;
}

export const InfoErrorList: React.FC<InfoErrorListProps> = ({
    errors = [],
}) => {
    if (!errors) return '';
    const { t } = useTranslation();

    const errorList = useMemo(() => {
        if (Array.isArray(errors)) {
            return errors;
        }
        if (typeof errors !== 'string') {
            if (errors?.message && 'message' in errors) {
                return [errors?.message];
            }

            return [t('advisoryDashboard.errorText')];
        }

        return [errors];
    }, [errors]);

    return (
        <div className="InfoErrorList">
            {errorList?.map((error) => (
                <Infobox error>{error}</Infobox>
            ))}
        </div>
    );
};
